import PropTypes from 'prop-types';
import React from 'react';

import { Badge, Button, Select } from 'twyne-new.ui';

import Label from '../pure/rules/Label';
import RuleGroupWrapper from '../pure/rules/RuleGroup';

import RuleGroupItem from './RuleGroupItem';
import { conditionOptions, conditionsLabels } from './options';

const RuleGroup = ({ data, loadRuleKeys, onAddRow, onDeleteRow, index, onDeleteGroup, onChange, condition, origin, disabled, getDisabled, handleOpenValidatorModal  }) => {
  const handleChangeRow = (index, row) => {
    const group = data;
    group.rules[index] = row;
    onChange(group);
  }

  const handleChangeCondition = opt => {
    const group = data;
    group.condition = opt ? opt.value : null;
    onChange(group);
  }

  return <RuleGroupWrapper className='twy-border-base-accent'>
    <div className="flex justify-between items-center mb-4">
      <div className='flex items-center gap-2'>
        <Label className='whitespace-nowrap'>
          Match with
        </Label>
        <Select
          className="w-[5vw]!"
          value={data.condition}
          clearable={false}
          options={conditionOptions}
          onChange={handleChangeCondition}
          disabled={disabled}
        />
        <Label>conditions</Label>
      </div>
      <div className='flex items-start gap-2'>
        <Button variant='outline' size="sm" onClick={onDeleteGroup} disabled={disabled}>
          Delete Group
        </Button>
        <Button variant='outline' size="sm" color="success" onClick={() => onAddRow(index)} disabled={disabled}>
          Add Condition
        </Button>
      </div>
    </div>
    {data.rules.map((rule, rowIndex, { length }) => <React.Fragment key={rowIndex}>
      <RuleGroupItem data={rule} origin={origin} key={rowIndex}
        loadRuleKeys={loadRuleKeys} index={rowIndex}
        onDeleteRow={() => onDeleteRow(index, rowIndex)}
        condition={data.condition}
        onChange={rowData => handleChangeRow(rowIndex, rowData)}
        disabled={disabled || getDisabled(rule, rowIndex)}
        handleOpenValidatorModal={handleOpenValidatorModal}
      />
      {rowIndex < length - 1 && <Badge variant='light' className='my-4 uppercase font-semibold'>{conditionsLabels[data.condition] || data.condition}</Badge>}
    </React.Fragment>,
    )}
  </RuleGroupWrapper>
};

RuleGroup.propTypes = {
  data: PropTypes.object,
  loadRuleKeys: PropTypes.func,
  onAddRow: PropTypes.func,
  onDeleteRow: PropTypes.func,
  index: PropTypes.number,
  onDeleteGroup: PropTypes.func,
  onChange: PropTypes.func,
  origin: PropTypes.oneOf(['integration', 'page', 'path-page', 'profile', 'form-visibility', 'form-populate']),
  disabled: PropTypes.bool,
  condition: PropTypes.string,
  handleValidatorModal: PropTypes.func,
}

export default RuleGroup;
